<template lang="pug">
  v-app 
    n-navbar
    //- canvas#canvasCelebrate(
    //-   style='z-index:220; position: absolute; pointer-events:none;'
    //- )
    v-container(
      :class="{ 'new-layout': !useCardBG, 'bg_home_tp': isThaiCharoenPlus }").layoutcontrol-v2(fluid)
      v-main.pt-5
        v-card(
          v-if="useCardBG"
          color="var(--bg-home)"
          min-height="100vh"
        ).pt-5.px-2.n-card
          router-view 
        router-view(v-else)
    menu-bar(v-if="!hideMenu")
    dialog-add-voucher-success(ref='rDialogSuccess')
        
      //- bottom-navigation(v-if="isMobile && !hideMenu")
      //- dialog-add-voucher-success(ref='rDialogSuccess')
      
    LiveChatWidget(
      v-if="isLogin && agentInfo.live_chat_key"
      :license="agentInfo.live_chat_key"
      visibility="hidden"
      :customer-name="userProfile.username"
      :customer-email="userProfile.email"
      v-on:visibility-changed="onVisibilityChanged"
    )
</template>

<script>  
import NNavbar from "@/components/AppBar/NavbarAfterLogin-v3";
import MenuBar from "@/components/AppBar/MenuBar";
import DialogAddVoucherSuccess from '@/views/Vouchers/childs/DialogAddVoucherSuccess'
import { ROUTE_GAME_TYPE, ROUTE_INDEX, ROUTE_SETTING, ROUTE_GAME_LOTTO_DETAIL } from '@/const/route'
import { vouchers as apiVouchers } from '@/apis'
import { LiveChatWidget } from '@livechat/widget-vue/v2'
import { agentInfo as apiAgentInfo } from '@/apis'  

export default {
  name: "App",  
  components: { 
    NNavbar,
    MenuBar,
    DialogAddVoucherSuccess,
    LiveChatWidget,
  },
  data: () => ({   
    agentInfo: {},
  }), 
  computed: {
    routeName () {
      return this.$route.name
    },
    useCardBG () {
      return ROUTE_INDEX !== this.routeName && ROUTE_GAME_TYPE !== this.routeName
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    isMobile () {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    isLogin () {
      return this.$store.getters['auth/GETTERS_TOKEN'] !== null
    },
    hideMenu () {
      return this.routeName == ROUTE_GAME_LOTTO_DETAIL
    }
  },
  watch : {
    userProfile () {
      if(this.userProfile){
        this.checkAccount() 
      }
    },
    wallet () {
      if(this.wallet){
        this.checkPromotion() 
      }
    },
  },
  async created () {
    if (this.isLogin) {
      this.getAgentInfo()
    }
  },
  updated () {
    this.checkAccount()
  },  
  methods: {
    checkAccount () {
      if (this.$route.name == ROUTE_SETTING) {
        return
      }

      if (this.userProfile.bank_type === null) {
        this.$router.push({ name: ROUTE_SETTING, query: { tab: 'bank', popup: 1 } }).catch(() => {}); 
        return
      }
    },
    async checkPromotion () {
      let selectedVoucher = JSON.parse(localStorage.getItem('selectedVoucher')) || null
      let currentPurchasedAmount = localStorage.getItem('currentPurchasedAmount')

      if (!selectedVoucher) {
        return
      }

      if (this.wallet.purchased_amount < currentPurchasedAmount + selectedVoucher.rules.topup_amount) {
        return
      }

      let form = {
        code: selectedVoucher.code
      }

      const [err, data,,,] = await apiVouchers.redeem(form)

      localStorage.removeItem('selectedVoucher') 
      localStorage.removeItem('currentPurchasedAmount')

      if(err) { 
        return
      }

      data.image = selectedVoucher.image_url

      this.$refs.rDialogSuccess.open(data)      
    },
    async getAgentInfo (){
      const [err, data] = await apiAgentInfo.get()
      
      if (err) {
        return
      }     
      this.agentInfo = data 
    },
    onVisibilityChanged (event) {
      switch (event.visibility) {
        case "maximized":
          break;
        case "minimized":
          window.LC_API.hide_chat_window();
          break;
        case "hidden":
          break;
      }
    }
  }
};
</script>

<style >
.layoutcontrol-v2 {
  padding-bottom: 100px;
}

.new-layout {
  padding-left: 0;
  padding-right: 0;
}

.n-card {
  padding-bottom: 60px;
  box-shadow: unset !important;
}

.bg_home_tp {
  background-image: url('~@/assets/v3/bg7-tp-main.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top center;
  background-attachment: fixed;
}
</style>